/* eslint-disable react-hooks/exhaustive-deps */
import { Column } from '@access-erp/common';
import { CellType, FilterValueTypes } from '@access-erp/ui-components';
import { useMemo } from 'react';

import { renderCustomerAccountCode }
  from '@/components/common/EnquiriesScreen/customFilters/CustomerAccountNumberMultiSelect';
import { guidFilterOptions } from '@/components/common/EnquiriesScreen/utils/filters.config';

export const useHeaderColumns = () => {
  let filterIndex = 1;
  const nextFilter = () => filterIndex++;

  const headerColumns: Column<any>[] = [
    {
      name: 'customerName',
      caption: 'Account Name',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'customerAccountNumber',
      caption: 'Account Number',
      cellType: CellType.String,
      width: 250,
      defaultFilter: nextFilter(),
      filterType: FilterValueTypes.StringMultiSelectFilter,
      renderFilter: (renderProps) =>
        renderCustomerAccountCode({ ...renderProps, title: 'Account Number' }),
    },
    {
      name: 'address',
      caption: 'Address',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'town',
      caption: 'Town',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'state',
      caption: 'State',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'postCode',
      caption: 'Postcode',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'country',
      caption: 'Country',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'emailAddress',
      caption: 'Email Address',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'ccEmailAddress',
      caption: 'CC Email Address',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'contactName',
      caption: 'Contact Name',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'contactPhoneNumber',
      caption: 'Contact Phone Number',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'salesPersonName',
      caption: 'Sales Person Name',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'accountManagerName',
      caption: 'Account Manager Name',
      width: 250,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
    },
    {
      name: 'customerID',
      caption: 'ID',
      width: 270,
      cellType: CellType.String,
      defaultFilter: nextFilter(),
      hidden: true,
      filterType: FilterValueTypes.StringFilter,
      filterOptions: {
        availableOptions: guidFilterOptions,
      }
    },
  ];

  return useMemo(() => ({ headerColumns }), []);
};
